var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    editable: _vm.editable,
                    type: "search",
                    comboItems: _vm.useFlagItems,
                    itemText: "codeName",
                    itemValue: "code",
                    label: "사용여부",
                    name: "useFlag",
                  },
                  on: { datachange: _vm.getList },
                  model: {
                    value: _vm.searchParam.useFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "useFlag", $$v)
                    },
                    expression: "searchParam.useFlag",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" },
          [
            _c(
              "c-tree-table",
              {
                attrs: {
                  title: "폴더 목록",
                  parentProperty: "koshaParentFolderId",
                  customID: "koshaFolderId",
                  columns: _vm.gridFolder.columns,
                  data: _vm.gridFolder.data,
                  columnSetting: false,
                  usePaging: false,
                  expandAll: true,
                },
                on: { linkClick: _vm.rowClick },
                scopedSlots: _vm._u([
                  {
                    key: "customArea",
                    fn: function ({ props, col }) {
                      return [
                        [
                          col.name === "rowFolder"
                            ? _c(
                                "q-chip",
                                {
                                  staticStyle: {
                                    "margin-bottom": "4px !important",
                                  },
                                  attrs: {
                                    color: "amber",
                                    clickable: true,
                                    "text-color": "white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return (() =>
                                        _vm.openPop(props.row, "ROWNEW")).apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" ▼New ")]
                              )
                            : _vm._e(),
                          col.name === "editFolder"
                            ? _c(
                                "q-chip",
                                {
                                  staticStyle: {
                                    "margin-bottom": "4px !important",
                                  },
                                  attrs: {
                                    color: "blue",
                                    clickable: true,
                                    "text-color": "white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.chipClick(
                                        props.row,
                                        col,
                                        props.pageIndex
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Edit ")]
                              )
                            : _vm._e(),
                          col.name === "openFolder"
                            ? _c(
                                "q-chip",
                                {
                                  staticStyle: {
                                    "margin-bottom": "4px !important",
                                  },
                                  attrs: {
                                    color: "green",
                                    clickable: true,
                                    "text-color": "white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.rowClick(props.row)
                                    },
                                  },
                                },
                                [_vm._v(" Open▶ ")]
                              )
                            : _vm._e(),
                        ],
                      ]
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable
                          ? _c("c-btn", {
                              attrs: { label: "등록", icon: "add" },
                              on: { btnClicked: _vm.openPop },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7" },
          [
            _c(
              "c-table",
              {
                attrs: {
                  title: "KOSHA 목록",
                  rowKey: "id",
                  columns: _vm.gridProcedure.columns,
                  data: _vm.gridProcedure.data,
                  columnSetting: false,
                  isFullScreen: false,
                  usePaging: false,
                  expandAll: true,
                },
                on: { linkClick: _vm.linkClick },
                scopedSlots: _vm._u([
                  {
                    key: "customArea",
                    fn: function ({ props }) {
                      return [
                        [
                          Boolean(props.row.folderLink)
                            ? _c(
                                "q-chip",
                                {
                                  staticStyle: {
                                    "margin-bottom": "4px !important",
                                  },
                                  attrs: {
                                    color: "amber",
                                    clickable: true,
                                    "text-color": "white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return (() =>
                                        _vm.openLink(props.row)).apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 바로가기 ")]
                              )
                            : _vm._e(),
                        ],
                      ]
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "table-chip" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c(
                          "q-chip",
                          [
                            _c("q-avatar", {
                              attrs: {
                                icon: "bookmark",
                                color: "green",
                                "text-color": "white",
                              },
                            }),
                            _vm._v(
                              " " + _vm._s("폴더명 : " + _vm.folderName) + " "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.folderName
                          ? _c("c-btn", {
                              attrs: { label: "등록", icon: "add" },
                              on: { btnClicked: _vm.procedureAdd },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }